module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MDAiIGhlaWdodD0iNDAwIiB2aWV3Qm94PSIwIDAgMjcgMTgiPjxwYXRoIGZpbGw9IiMwRDVFQUYiIGQ9Ik0wIDBoMjd2MThIMHoiLz48cGF0aCBmaWxsPSJub25lIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZT0iI0ZGRiIgZD0iTTUgMHYxMU0wIDVoMTBtMC0yaDE3TTEwIDdoMTdNMCAxMWgyN00wIDE1aDI3Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/grc.svg
// module id = AlBz
// module chunks = 0